import * as Types from '../../declarations'
import TrekCard from '../TrekCard'
import { tripPageTripToTripCard } from '../../lib/helper'
import SectionHeader from './components/SectionHeader'

interface Props {
	trip: Types.DB.Models.TripAttributes
}

const Similar = ({ trip }: Props) => {
	const {
		similarTrips,
		name,
		jsonData: { trekOrClimb },
	} = trip
	if ((similarTrips ?? []).length === 0) return <></>

	const isTrek = trekOrClimb === 'TREK'

	return (
		<div id="similar-wrapper" className="spacing-between-sections-above">
			<SectionHeader
				title={`Similar ${
					trekOrClimb === 'CLIMB' ? 'climbs' : 'treks'
				} to ${name}`}
				section={Types.App.DataTypes.FeedbackSection.SIMILAR}
			/>
			<p>
				These {isTrek ? 'treks' : 'climbs'} are similar in length, difficulty,
				and elevation. Offering a similar level of challenge as the {name}{' '}
				{isTrek ? 'trek' : 'climb'}.
			</p>

			<div id="similar-items" className="trek-card-container">
				{similarTrips?.map((similarTrip, key) => (
					<TrekCard
						tripCardProps={tripPageTripToTripCard(similarTrip)}
						key={key}
					/>
				))}
			</div>
		</div>
	)
}

export default Similar
